export default "__VITE_ASSET__ee55c79e__"